import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, } from '@/components/ui/dialog';
import { Kbd } from '@/components/Kbd';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';
const ctx = createContext(null);
/** Provedor global do modal de atalhos — "?" abre em qualquer lugar. */
export function ShortcutsHelpProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const api = useMemo(() => ({
        open: () => setIsOpen(true),
        close: () => setIsOpen(false),
        toggle: () => setIsOpen((v) => !v),
    }), []);
    const shortcuts = useMemo(() => [
        {
            key: 'Shift+?',
            handler: () => setIsOpen((v) => !v),
            description: 'Exibir atalhos',
        },
        {
            key: '/',
            handler: () => setIsOpen((v) => !v),
            description: 'Exibir atalhos',
        },
    ], []);
    useKeyboardShortcuts(shortcuts);
    return (_jsxs(ctx.Provider, { value: api, children: [children, _jsx(ShortcutsDialog, { open: isOpen, onOpenChange: setIsOpen })] }));
}
export function useShortcutsHelp() {
    const v = useContext(ctx);
    if (!v)
        throw new Error('useShortcutsHelp fora de ShortcutsHelpProvider');
    return v;
}
function ShortcutsDialog({ open, onOpenChange, }) {
    const rows = useMemo(() => [
        {
            group: 'Navegação',
            items: [
                { keys: ['Shift+?', '/'], label: 'Abrir/fechar atalhos' },
                { keys: ['Esc'], label: 'Fechar diálogos e limpar seleção' },
            ],
        },
        {
            group: 'Biblioteca',
            items: [
                { keys: ['N'], label: 'Novo projeto' },
            ],
        },
        {
            group: 'Configurador — Camadas',
            items: [
                { keys: ['V'], label: 'Alternar visibilidade da camada selecionada' },
                { keys: ['L'], label: 'Bloquear/desbloquear a camada selecionada' },
                { keys: ['Delete', 'Backspace'], label: 'Remover camada selecionada' },
            ],
        },
        {
            group: 'Configurador — Viewport',
            items: [
                { keys: ['1'], label: 'Modo realista' },
                { keys: ['2'], label: 'Modo técnico' },
                { keys: ['3'], label: 'Modo explodido' },
                { keys: ['4'], label: 'Modo corte' },
                { keys: ['H'], label: 'Câmera — Hero' },
                { keys: ['T'], label: 'Câmera — Topo' },
                { keys: ['S'], label: 'Câmera — Lateral' },
                { keys: ['I'], label: 'Câmera — Isométrica' },
            ],
        },
        {
            group: 'Configurador — Projeto',
            items: [
                { keys: ['Mod+E'], label: 'Exportar projeto (JSON)' },
            ],
        },
    ], []);
    return (_jsx(Dialog, { open: open, onOpenChange: onOpenChange, children: _jsxs(DialogContent, { className: "max-w-xl", children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: "Atalhos de teclado" }), _jsxs(DialogDescription, { children: ["Aperte ", _jsx(Kbd, { children: "Shift+?" }), " ou ", _jsx(Kbd, { children: "/" }), " em qualquer lugar para abrir esta ajuda."] })] }), _jsx("div", { className: "mt-5 space-y-5", children: rows.map((section) => (_jsxs("section", { children: [_jsx("p", { className: "text-[11px] uppercase tracking-wider font-bold text-muted-foreground mb-2", children: section.group }), _jsx("ul", { className: "divide-y divide-border border-y border-border", children: section.items.map((item) => (_jsxs("li", { className: "flex items-center justify-between py-2 text-sm", children: [_jsx("span", { children: item.label }), _jsx("span", { className: "flex items-center gap-1", children: item.keys.map((k, i) => (_jsxs("span", { className: "flex items-center gap-1", children: [_jsx(Kbd, { children: k.replace('Mod', navigator.platform.includes('Mac') ? '⌘' : 'Ctrl') }), i < item.keys.length - 1 && (_jsx("span", { className: "text-muted-foreground text-xs", children: "ou" }))] }, k))) })] }, item.label))) })] }, section.group))) })] }) }));
}
